import { FieldSchema } from "../../../Schema";
import { Reason } from "../external-sources/Reasons";

export const editComment: FieldSchema = {
  name: "editComment",
  display: { displayed: false },
  data: { maxLength: 80 },
  validation: {
    required: {
      getter: ({ editReason }) => (editReason as Reason)?.id === "other",
      fields: ["editReason"],
    },
  },
  form: { label: "Comment" },
};
